<template>
  <!-- NOTE (TEMPLATE) to show all Phds -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/watingforCommercializingPhds'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <v-row class="header-box btn-radius mb-6 pa-1 ps-2">
        <v-col>
          <h4 style="margin-top: 9px">رساله‌های در انتظار تجاری‌سازی</h4>
        </v-col>
        <v-col>
          <v-btn
            class="bc-primary text-white btn-radius float-end"
            width="200"
            height="45"
            elevation="0"
            @click="$refs.table1.$el.click()"
            :disabled="isBusy || !computedItems.length"
          >
            <span class="fs-small">
              خروجی اکسل

              <v-icon>$Excel</v-icon></span
            >
          </v-btn>
          <vue-excel-xlsx
            v-show="false"
            ref="table1"
            :data="computedItems"
            :columns="excelFields"
            :filename="'لیست-رساله-های-در-انتظار-تجاری-سازی'"
            :sheetname="currentDate"
          >
            دریافت اکسل
          </vue-excel-xlsx>
        </v-col>
      </v-row>
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-Phds) to show all Phds -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="هنوز طرحی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <!-- NOTE (<a>) button of "ersal e eslahieh" -->
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <a
              class="btn btn-primary text-light mx-1"
              style="width: 100%"
              :href="'/admin/completePhdProposal/' + data.item.id"
              v-if="data.item.status == 'نیاز به تکمیل / اصلاح'"
              >ارسال اصلاحیه</a
            >

            <!-- NOTE (<a>) to go to the complete proposal page  -->
            <a
              class="btn btn-primary text-light mx-1"
              style="width: 100%"
              :href="'/admin/completePhdProposal/' + data.item.id"
              v-if="data.item.status == 'پیش نویس'"
              target="_blank"
              >تکمیل طرح</a
            >
            <!-- NOTE (<a>) to go to the "moshahedeh tarh" -->
            <a
              class="btn btn-secondary mx-1"
              style="width: 100%"
              :href="'/admin/phdProposal/' + data.item.id"
              v-if="data.item.status != 'پیش نویس'"
              >مشاهده طرح</a
            >

            <!-- NOTE (b-cancelProposal) to cancel the proposal -->
            <b-button
              v-if="
                data.item.status == 'ثبت شده' || data.item.status == 'پیش نویس'
              "
              class="btn btn-danger mx-1"
              style="width: 100%"
              :disabled="isBusy"
              @click="cancelProposal(data.item)"
              >لغو طرح</b-button
            >
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div
            v-if="data.item.status == 'ثبت شده'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-vimeo p-2" disabled
              >ثبت شده</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'در انتظار بهره‌بردار'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-vimeo p-2" disabled
              >در انتظار بهره‌بردار</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'درحال بررسی'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-xing p-2" disabled
              >درحال بررسی</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'در دست داوری'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-css3 p-2" disabled
              >در دست داوری</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'جمع بندی نظرات داوران'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-warning p-2" disabled
              >جمع بندی نظرات داوران</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'تایید نهایی'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-success" disabled
              >تایید نهایی</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'اصلاح شده'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-flickr" disabled
              >اصلاح شده</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'مرحله دوم'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-dark" disabled
              >مرحله دوم</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'نیاز به تکمیل / اصلاح'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-danger" disabled
              >نیاز به تکمیل / اصلاح</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'پذیرش اولیه'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-info p-2" disabled
              >پذیرش اولیه</b-button
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  components: {},
  data: function () {
    return {
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "university", label: "دانشگاه" },
        { key: "version", label: "نسخه" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "faSubject", label: "عنوان فارسی" },
        { field: "requestsCode", label: "کد طرح" },
        { field: "registerDate", label: "تاریخ ثبت" },
        { field: "status", label: "وضعیت" },
        { field: "university", label: "دانشگاه" },
        { field: "version", label: "نسخه" },
        { field: "lastUpdate", label: "آخرین بروزرسانی" },
      ],
      items: [],
      filter: "",
      isBusy: true,
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getData() {
      // NOTE (m-getData) to get Phds data to show them
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/requests/phd/waitingforCommercializing",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.isBusy = false;
          this.totalRows = this.items.length;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },

    cancelProposal(item) {
      // NOTE (m-cancelProposal) to cancel a proposal
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/cancelProject",
          {
            projectId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.getData();
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast(
            err.response.data + ". لطفا با پشتیبانی تماس بگیرید.",
            "error"
          );
        });
    },
  },
  computed: {
    computedItems() {
      if (this.items) {
        return this.items.sort((a, b) => {
          if (a.time < b.time) {
            return 1;
          }
          if (a.time > b.time) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
  },
  mounted() {
    if (this.$router.currentRoute.path == "/admin/watingforCommercializingPhds")
      this.getData();
  },
  updated() {
    if (this.isBusy) this.getData();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}
</style>
